import { SvgImage } from '@fl/cmsch-fe-library';
import antdLocaleCsCZ from 'antd/es/locale/cs_CZ';
import antdLocaleEnGB from 'antd/es/locale/en_GB';
import { Locale } from 'antd/es/locale-provider';
import React from 'react';
import { Language } from 'api/gen/Language';
import CzFlag from './cz.svg';
import GbFlag from './gb.svg';
interface LanguageDetails {
  legacyBeTag: string;
  antdLocalizationFile: Locale;
  label: string;
  icon: React.ReactElement;
}

/** Supported application languages and their shell-level UI metadata. */
export const LANGUAGES: Record<Language, LanguageDetails> = {
  CS: {
    legacyBeTag: 'cs-CZ',
    antdLocalizationFile: antdLocaleCsCZ,
    label: 'Česky',
    icon: <SvgImage image={CzFlag} />
  },
  EN: {
    legacyBeTag: 'en-GB',
    antdLocalizationFile: antdLocaleEnGB,
    label: 'English',
    icon: <SvgImage image={GbFlag} />
  }
};